'use strict';

frontendApp.directive('iioTagPopover', ['$rootScope', '$compile', '$parse', '$document', '$uibPosition', function ($rootScope, $compile, $parse, $document, $uibPosition) {

  var html = $document.find('html');

  var template =
    '<iio-tag-popover-popup ' +
    'tag="tag" ' +
    'placement="{{ tt_placement }}" ' +
    'is-open="tt_isOpen" ' +
    '>' +
    '</iio-tag-popover-popup>';

  var chosenScope = null;
  var closeChosenOne = function () {
    if (chosenScope)
      chosenScope.hide();
  };

  $rootScope.$on('iioPopoverClose', function (evt) {
    closeChosenOne();
  });

  return {
    restrict: 'EA',
    scope: {
      tag: '='
    },
    link: function (scope, element, attrs) {

      var tooltip = $compile(template)(scope);
      var $body;

      // By default, the tooltip is not open.
      scope.tt_isOpen = false;

      function toggleTooltipBind(evt) {
        evt.stopPropagation();
        if (!scope.tt_isOpen) {
          closeChosenOne();
          showTooltipBind();
        } else {
          hideTooltipBind();
        }
      }

      function showTooltipBind() {
        scope.$apply(function () {
          show();
        });

        // html.bind('click', function(evt) {
        //     console.log('Html click handler');
        //     hideTooltipBind();
        // });
      }

      function hideTooltipBind() {
        scope.$apply(function () {
          scope.hide();
        });
      }

      function show() {
        var position,
          ttWidth,
          ttHeight,
          ttPosition;

        // Set the initial positioning.
        tooltip.css({top: 0, left: 0, display: 'block'});

        // Now we add it to the DOM because need some info about it. But it's not
        // visible yet anyway.
        $body = $body || $document.find('body');
        $body.append(tooltip);

        // Get the position of the directive element.
        position = $uibPosition.offset(element);

        // Get the height and width of the tooltip so we can center it.
        ttWidth = tooltip.prop('offsetWidth');
        ttHeight = tooltip.prop('offsetHeight');

        // Calculate the tooltip's top and left coordinates to center it with
        // this directive.
        switch (scope.tt_placement) {
          case 'mouse':
            var mousePos = $uibPosition.mouse();
            ttPosition = {
              top: mousePos.y,
              left: mousePos.x
            };
            break;
          case 'right':
            ttPosition = {
              top: position.top + position.height / 2 - ttHeight / 2,
              left: position.left + position.width
            };
            break;
          case 'bottom':
            ttPosition = {
              top: position.top + position.height,
              left: position.left + position.width / 2 - ttWidth / 2
            };
            break;
          case 'left':
            ttPosition = {
              top: position.top + position.height / 2 - ttHeight / 2,
              left: position.left - ttWidth
            };
            break;
          default:
            ttPosition = {
              top: position.top - ttHeight,
              left: position.left + position.width / 2 - ttWidth / 2
            };
            break;
        }

        ttPosition.top += 'px';
        ttPosition.left += 'px';

        // Now set the calculated positioning.
        tooltip.css(ttPosition);
        chosenScope = scope;

        // And show the tooltip.
        scope.tt_isOpen = true;
      }

      // Hide the tooltip popup element.
      scope.hide = function () {
        scope.tt_isOpen = false;
        $(tooltip).detach();
      };

      /**
       * Observe the relevant attributes.
       */
      attrs.$observe('iioTagPopoverPlacement', function (val) {
        scope.tt_placement = val;
      });

      element.bind('click', toggleTooltipBind);

      // Make sure tooltip is destroyed and removed.
      scope.$on('$destroy', function onDestroyTooltip() {
        if (scope.tt_isOpen) {
          scope.hide();
        } else {
          $(tooltip).detach();
        }
      });

      scope.$on('$locationChangeSuccess', function () {
        if (scope.tt_isOpen) {
          scope.hide();
        }
      });


    }
  };

}]);
